import { ILivechatGroup } from "interfaces/entities/livechat";
import { Action, ISinglePayloadError } from "services/websocket/interfaces";
import {
  IEntityFetchFailure,
  RequestAction,
  createEntityActionNames,
  createEntityActions,
  createRequestTypes,
} from "store/entities/actions";
import { ActionsUnion, createAction } from "store/helper";

import {
  IIntegration,
  ILiveChatImportDiffFailurePayload,
  ILiveChatImportDiffSuccessPayload,
  ILiveChatSelectiveImportFetchFailurePayload,
  ILiveChatSelectiveImportFetchSuccessPayload,
  ILiveChatSelectiveImportStartFailurePayload,
  ILiveChatSelectiveImportStartPayload,
  ILiveChatSelectiveImportStartSuccessPayload,
  IMarkLiveChatIntegrationTutorialAsVisitedFailurePayload,
  IMarkLiveChatIntegrationTutorialAsVisitedSuccessPayload,
  ISyncDeleteIntegrationPayload,
} from "./interfaces";

export const INTEGRATION = {
  ...createEntityActionNames("INTEGRATION"),
  FETCH_LIVECHAT_GROUPS: createRequestTypes("ENTITIES/INTEGRATION/FETCH_LIVECHAT_GROUPS"),
  MARK_LIVECHAT_TUTORIAL_AS_VISITED: createRequestTypes(
    "ENTITIES/INTEGRATIONS/MARK_LIVECHAT_INTEGRATION_TUTORIAL_AS_VISITED"
  ),
  SYNC_DELETE: "ENTITIES/INTEGRATIONS/SYNC_DELETE",

  LIVECHAT_SELECTIVE_IMPORT_FETCH: createRequestTypes("ENTITIES/INTEGRATION/LIVECHAT_SELECTIVE_IMPORT_FETCH"),
  LIVECHAT_SELECTIVE_IMPORT_START: createRequestTypes("ENTITIES/INTEGRATION/LIVECHAT_SELECTIVE_IMPORT_START"),
  LIVECHAT_SELECTIVE_IMPORT_FINISHED: "ENTITIES/INTEGRATIONS/LIVECHAT_SELECTIVE_IMPORT_FINISHED",
  LIVECHAT_IMPORT_DIFF: createRequestTypes("ENTITIES/INTEGRATION/LIVECHAT_IMPORT_DIFF"),
} as const;

const liveChatSelectiveImportActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLiveChatSelectiveImport: () => createAction(INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_FETCH[RequestAction.REQUEST]),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLiveChatSelectiveImportSuccess: (payload: ILiveChatSelectiveImportFetchSuccessPayload) =>
    createAction(INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_FETCH[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLiveChatSelectiveImportFailure: (payload: ILiveChatSelectiveImportFetchFailurePayload) =>
    createAction(INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_FETCH[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  startLiveChatSelectiveImport: (payload: ILiveChatSelectiveImportStartPayload) =>
    createAction(INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_START[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  startLiveChatSelectiveImportSuccess: (payload: ILiveChatSelectiveImportStartSuccessPayload) =>
    createAction(INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_START[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  startLiveChatSelectiveImportFailure: (payload: ILiveChatSelectiveImportStartFailurePayload) =>
    createAction(INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_START[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLiveChatImportDiff: () => createAction(INTEGRATION.LIVECHAT_IMPORT_DIFF[RequestAction.REQUEST]),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLiveChatImportDiffSuccess: (payload: ILiveChatImportDiffSuccessPayload) =>
    createAction(INTEGRATION.LIVECHAT_IMPORT_DIFF[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLiveChatImportDiffFailure: (payload: ILiveChatImportDiffFailurePayload) =>
    createAction(INTEGRATION.LIVECHAT_IMPORT_DIFF[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  liveChatSelectiveImportFinished: (payload: { action: Action; error?: ISinglePayloadError }) =>
    createAction(INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_FINISHED, payload),
};

type FetchLivechatGroupsPayload = ILivechatGroup[];

const liveChatGroupsActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLivechatGroups: () => createAction(INTEGRATION.FETCH_LIVECHAT_GROUPS[RequestAction.REQUEST]),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLivechatGroupsSuccess: (payload: FetchLivechatGroupsPayload) =>
    createAction(INTEGRATION.FETCH_LIVECHAT_GROUPS[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLivechatGroupsFailure: (payload: IEntityFetchFailure) =>
    createAction(INTEGRATION.FETCH_LIVECHAT_GROUPS[RequestAction.FAILURE], payload),
};

export const IntegrationsActions = {
  ...createEntityActions<IIntegration>(INTEGRATION),
  ...liveChatGroupsActions,
  ...liveChatSelectiveImportActions,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  markLiveChatIntegrationTutorialAsVisited: () =>
    createAction(INTEGRATION.MARK_LIVECHAT_TUTORIAL_AS_VISITED[RequestAction.REQUEST]),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  markLiveChatIntegrationTutorialAsVisitedSuccess: (payload: IMarkLiveChatIntegrationTutorialAsVisitedSuccessPayload) =>
    createAction(INTEGRATION.MARK_LIVECHAT_TUTORIAL_AS_VISITED[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  markLiveChatIntegrationTutorialAsVisitedFailure: (payload: IMarkLiveChatIntegrationTutorialAsVisitedFailurePayload) =>
    createAction(INTEGRATION.MARK_LIVECHAT_TUTORIAL_AS_VISITED[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDelete: (payload: ISyncDeleteIntegrationPayload) => createAction(INTEGRATION.SYNC_DELETE, payload),
};

export type IntegrationsAction = ActionsUnion<typeof IntegrationsActions>;
